function accordion(){
    const questions = document.querySelectorAll('.accordion .faq-question');
    questions.forEach((question) => {
        question.addEventListener('click', function(){
            
            var show = document.querySelector('.accordion .show');
            if(show){
                show.classList.remove('show');
            }

            var answer = document.getElementById(question.dataset.answer);
            answer.classList.add('show');

        });
    });
}